/** Marks UI slices fed by prototype catalog, not yet from ConverseEngine. */
export function DummyBadge({ label = 'dummy' }: { label?: string }) {
  return (
    <span className="na-dummy-tag" title="Illustrative data — not yet from live bot">
      {label}
    </span>
  );
}
